import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  chooseLocation: {
    defaultMessage: 'Choose Location',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.LocationSelect.chooseLocation`,
  },
});
export default messages;
